import { render } from "./buy-certificate.vue?vue&type=template&id=7ffdf878"
import script from "./buy-certificate.vue?vue&type=script&lang=js"
export * from "./buy-certificate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__